<template>
  <div class="p-l-30 p-r-100">
    <p class="header">项目公告</p>
    <section class="p-lr-30 p-tb-20" v-if="!isShowEdit">
      <div class="noticeContent f-s-14 m-b-20" v-html="projectNotice"></div>
      <el-button
        v-if="taskType == 1 && status == 2"
        type="primary"
        size="medium"
        @click="gotoEdit"
      >
        修改公告
      </el-button>
    </section>
    <section class="p-30" v-if="isShowEdit">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="projectNotice"
        maxlength="1000"
        resize="none"
        show-word-limit
        :autosize="{ minRows: 2, maxRows: 8 }"
      ></el-input>
      <div class="m-t-20">
        <el-button type="primary" size="small" @click="updateNotice">
          确定
        </el-button>
        <el-button size="small" @click="cancle">取消</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import { getByType, qcUpdatePeRemark } from '@/api/dot/flow';
export default {
  props: ['orderId', 'taskType', 'id', 'status'],
  data() {
    return {
      projectNotice: null,
      isShowEdit: false,
      orderFlow: '',
      flowId: '',
    };
  },
  watch: {
    orderId: function (n, o) {
      if (n) {
        // this.getNotice()
      }
    },
  },
  methods: {
    // 获取项目公告
    getNotice() {
      getByType({
        orderId: this.orderId,
        type: 6,
      }).then((res) => {
        this.projectNotice = res.data.data.remark;
        this.flowId = res.data.data.id;
        this.orderFlow = res.data.data.orderFlow;
      });
    },

    // 点击编辑
    gotoEdit() {
      this.isShowEdit = true;
    },

    // 取消
    cancle() {
      this.getNotice();
      this.isShowEdit = false;
    },

    // 修改项目公告
    updateNotice() {
      if (this.projectNotice.trim() == '') {
        this.$message.error('请输入公告内容');
        return;
      }
      qcUpdatePeRemark(this.id, {
        orderId: this.orderId,
        id: this.flowId,
        orderFlow: this.orderFlow,
        remark: this.projectNotice,
      }).then((res) => {
        this.getNotice();
        this.$message.success('修改成功');
        this.isShowEdit = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}
.noticeContent {
  white-space: pre-wrap;
  line-height: 26px;
}
</style>
